<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "RollingAnnounce",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'countryId',
        placeholder: '国家',
        type: 'select',
        selectUrl: '/country/getAll',
        selectData: [],
      }],
      permission: {
        add: 'rollingAnnounce:add',
        update: 'rollingAnnounce:update',
        delete: 'rollingAnnounce:delete',
        deleteBatch: 'rollingAnnounce:deleteBatch'
      },
      url: {
        get: '/rollingAnnounce/listByCondition',
        add: '/rollingAnnounce/add',
        update: '/rollingAnnounce/update',
        delete: '/rollingAnnounce/delete/',
        delete_batch: '/rollingAnnounce/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      }, {
        field: 'countryId',
        label: '国家ID',
        selectUrl: '/country/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      }, {
        field: 'content',
        label: '内容',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '添加滚动公告',
        updateTitle: '修改滚动公告',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'countryId',
          label: '国家ID',
          type: 'select',
          selectUrl: '/country/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择国家ID', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'content',
          label: '内容',
          type: 'textarea',
          placeholder: '内容',
          rules: [{message: '请输入内容', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
